export const DecoClassName = 'pm-emoji-input';
